import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { usePreferencesContext, useUserContext, useThemeContext } from 'contexts';
import { handleSearchResult } from 'components/search-bar/useSearchBar';
import useMapLocationChanger from 'hooks/use-map-location-changer';

import type SearchPrediction from 'data/search-predictions';
import type { ThemeNames } from 'types/themes';

/**
 * Hook to handle search result clicks across the application
 * 
 * When on the search/map page, this hook passes the map instance to move the map
 * instead of navigating away. On other pages, it navigates to the area page.
 *
 * @returns A callback function that handles search result clicks
 */
export const useSearchResultClick = (forceAreapage = false) => {
  const router = useRouter();
  const { listingParams, addToRecentSearches } = usePreferencesContext();
  const { user } = useUserContext();
  const { themeName } = useThemeContext();
  const [onSearchPage, setOnSearchPage] = useState(false);
  const map = useMapLocationChanger();

  // Detect if user is on the search/map page
  useEffect(() => {
    setOnSearchPage(window.location.pathname.startsWith('/search'));
  }, [router.pathname]);

  return (searchPrediction: SearchPrediction) => {
    handleSearchResult({
      searchPrediction,
      listingParams,
      user,
      map: onSearchPage ? map : undefined,
      addToRecentSearches,
      themeName: themeName as ThemeNames,
      forceAreapage,
    });
  };
};